// en.ts — 영어 문구
export const en = {
      _l: "en",
      eyebrow: "MolePin Airdrop · Free MOL",
      h1: 'Got BNB from an exchange?<br><span class="g">Claim 10,000 MOL — free.</span>',
      lede: "Each exchange deposit = <em>10,000 MOL</em> (up to 10). <em>Follow on X = 10,000 MOL</em> + <em>Telegram = 10,000 MOL</em> — that's <em>20,000 MOL</em> with no deposit at all. Up to <em>120,000 MOL</em> per wallet.",
      notConnected: "No wallet bound to the vein",
      exchLabel: "Vein-linked exchanges:",
      fcfsLabel: "Deners admitted",
      railTitle: "Seals of the Vein",
      sealDepName: "Deposit", sealDepDesc: "An exchange sent BNB (or a BNB-chain token) to your wallet. 10,000 MOL each, up to 10.",
      sealDepBtn: "Prove deposits",
      proveMore: function (n: number) { return "Prove more (" + n + "/10)"; },
      proveFull: "All 10 deposits claimed",
      sealXName: "Follow on 𝕏", sealXDesc: "Follow MolePin on 𝕏 → 10,000 MOL. One time only.",
      sealXBtn: "Bind 𝕏",
      sealTgName: "Telegram", sealTgDesc: 'Post "MolePin Up" in the group → 10,000 MOL. One time only.',
      sealTgBtn: "Open the burrow",
      stLocked: "Unsealed", stDone: "Sealed",
      digTitleLocked: "The mound stays shut", digSubLocked: "Gather all three seals to break the earth and dig your MOL.",
      digBtnLocked: "Seals incomplete",
      digTitleOpen: "The vein opens", digSubOpen: "Three seals burn gold. Strike the earth and take what the contract owes you.",
      digBtnOpen: "Dig for MOL",
      modalTitle: "Prove your deposits",
      eligibleNote: "⚠️ Only BNB sent directly from an exchange (Binance, Coinbase…) to your wallet counts, and it must be <b>at least 0.001 BNB</b>. Transfers from personal wallets, DEXs, or other people do NOT qualify.",
      modeScan: "Auto scan", modeTx: "Enter txids",
      scanHint: function (ex: string) { return "Scans your wallet for BNB sent from " + ex + "."; },
      scanBtn: "Search my deposits",
      txHint: "Paste up to 10 BNB deposit tx hashes, one per line.",
      txGuideTitle: "📖 How to find your TX hash",
      txGuideHint: "On BscScan, open your wallet's transactions. Find a row where From is an exchange (Binance etc.) with a green IN badge, then copy that Transaction Hash.",
      tryTxidTitle: "Not found automatically?",
      tryTxidBody: "Your exchange's hot wallet may not be in our list yet. You can paste your deposit's TX hash directly — open BscScan, find the exchange deposit (green IN), and copy its hash.",
      tryTxidBtn: "Enter TX hash manually",
      verifyTxBtn: "Verify txids",
      claimBtn: "Dig for MOL",
      loreTitle: "The Vein",
      loreBody: "<strong>Eldorasia</strong>, the underground kingdom of seventeen golden mole tribes. After sixteen vanished, the last heir — <strong>MolePin</strong> — digs anew. A <strong>Dener</strong> stands beside him as guardian of the vein. The seals are how the vein knows you are real.",
      trust: "An independent MolePin community campaign, not affiliated with any exchange. Eligibility rests only on public on-chain data. Signatures prove wallet ownership; no transfer or approval is ever requested. Nothing here is investment advice.",
      dexMsg: "<b>Name your wallet</b> — a readable name instead of 0x. DEXignation is live.",
      dexCta: "Create a name",
      linksTitle: "Vein Gates & Allies",
      linksSub: "Open an exchange to move BNB, or visit our allied realms.",
      linksExch: "Exchanges",
      linksPartner: "Allied sites",
      linksCommunity: "Community",
      linksChannelTag: "Channel · news",
      linksGroupTag: "Group · earn seal",
      linksDigmolTag: "Dener / Distributor",
      linksDexTag: "Partner",
      inappMsg: "Wallets don't work in this in-app browser. Open in your browser to continue.",
      inappBtn: "Open in browser",
      inappManual: "Tap the ⋯ menu → \"Open in external browser\".",
      // dynamic
      sealCount: function (n: number) { return n + " / 3"; },
      validCount: function (n: number) { return n + " deposit(s) verified"; },
      depositsFound: function (n: number, bnb?: string) { return n + " deposit" + (n > 1 ? "s" : "") + (bnb ? " (" + bnb + " BNB)" : "") + " ✓"; },
      willGetMol: function (m: string) { return "→ You'll receive " + m + " MOL"; },
      noDepositsBig: "0 BNB deposits",
      alreadyClaimed: "Already claimed",
      alreadyClaimedBig: "Already claimed",
      alreadyClaimedNote: "These deposits were already used for a claim",
      myTxTitle: "Already registered",
      myTxConfirmed: "claimed",
      myTxPending: "pending",
      noValid: "No eligible exchange deposits found",
      claimAmt: function (m: string) { return "Dig " + m + " MOL"; },
      noGas: "You need a little BNB for gas to claim. Add some BNB and try again.",
      errTxidUsed: "This deposit has already been claimed.",
      errBadSigner: "Signature error. Please refresh and try again.",
      errExpired: "The request expired. Please try again.",
      errWalletCap: "This wallet has reached the claim limit (10 deposits).",
      errClaimerLimit: "The airdrop is fully claimed (10,000 wallets reached).",
      errPaused: "Claims are temporarily paused.",
      errNothing: "Nothing to claim.",
      errTransferFail: "Token transfer failed. Please try again later.",
      dug: function (m: string) { return "You struck gold — " + m + " MOL is yours."; },
      needConnect: "Bind a wallet to the vein first.",
      overLimit: "Up to 10 txids.",
      fcfsClosed: "Full", fcfsRemaining: function (r: number) { return r + " seats left"; }, fcfsMax: "Trial full",
      errClosed: "All 10,000 Dener seats are taken.",
      errCap: "This wallet already dug its 10.",
      xBound: function (h: string) { return "𝕏 bound: @" + h; },
      tgHelp: "1. Join the group  2. Post \"MolePin Up\" or \"MolePin 화이팅\"  3. Done.",
      openTg: "Open Telegram", copyPhrase: "Copy \"MolePin Up\"", phraseCopied: "Copied!",
      errNoMM: "MetaMask required.", errNoCB: "Coinbase Wallet required.", cancelled: "Cancelled.",
      connTimeout: "No response from MetaMask. Please try connecting again.",
      connecting: "Connecting to MetaMask… Approve in the MetaMask app, then return here.",
      cancel: "Cancel",
      copyAddr: "Click to copy full address", copied: "✓ Copied!",
      disconnect: "Disconnect",
      donateTitle: "Donate",
      donateNote: "Ethereum · BNB Chain · Polygon",
      donateWarn: "Send only on these networks. Other networks may cause permanent loss.",
      donateCopied: "Address copied",
      wrongChainWarn: "Wrong network. Switch to BNB Smart Chain.",
      switchChainBtn: "Switch network",
      wrongChainAlert: "Please switch to the BNB Smart Chain network.",
      wrongChainRejected: "You need to switch networks to dig MOL.",
      bonusClaim: "Claim 10,000 MOL",
      bonusClaiming: "Requesting signature…",
      bonusPending: "Processing…",
      bonusReceived: "✓ Claimed",
      bonusDone: "You received 10,000 MOL!",
      bonusAlready: "Already claimed.",
      bonusNeedSeal: "Earn the seal first.",
      bonusCapReached: "Claim limit reached.",
      xErrDup: "This 𝕏 account already claimed a seal on another wallet. One X account per wallet.",
      xErrFollow: "Could not verify the follow. Follow MolePin on 𝕏 and try again.",
      xErrGeneric: "𝕏 authentication failed. Please try again shortly.",
      rsnBelowMin: "Must be at least 0.001 BNB",
      rsnNotExchange: "Not sent from an exchange",
      rsnRecipient: "Not sent to your connected wallet",
      rsnNotFound: "Transaction not found",
      rsnNotConfirmed: "Transaction not confirmed yet",
      rsnUnknown: "Not eligible",
};
export default en;